module.exports = __webpack_public_path__ + "assets/img/上传中 (3).bd2c1a15.png";